/** Known source aliases use shared Tailwind colors, independent of count/order. */
const SOURCE_COLOR_CLASSES: Readonly<Record<string, string>> = {
  mercadolibre: 'bg-meli-500',
  mercadolibrecl: 'bg-meli-500',
  mercadolibrecom: 'bg-meli-500',
  meli: 'bg-meli-500',
  portalinmobiliario: 'bg-meli-500',
  portalinmobiliariocom: 'bg-meli-500',
  portal: 'bg-neutral-900',
  yapo: 'bg-yapo-500',
  yapocl: 'bg-yapo-500',
  toctoc: 'bg-toctoc-500',
  toctoccom: 'bg-toctoc-500',
  fincaraiz: 'bg-fincaraiz-500',
  fincaraizcomco: 'bg-fincaraiz-500',
  metrocuadrado: 'bg-metrocuadrado-500',
  metrocuadradocom: 'bg-metrocuadrado-500',
  zonaprop: 'bg-zonaprop-500',
  zonapropcomar: 'bg-zonaprop-500',
  argenprop: 'bg-argenprop-500',
  argenpropcom: 'bg-argenprop-500',
  whatsapp: 'bg-whatsapp-500',
  whatsappbusiness: 'bg-whatsapp-500',
  instagram: 'bg-instagram-500',
  instagramads: 'bg-instagram-500',
  facebook: 'bg-facebook-500',
  facebookads: 'bg-facebook-500',
  facebookmessenger: 'bg-facebook-500',
  referido: 'bg-secondary-500',
  referidos: 'bg-secondary-500',
  recomendacion: 'bg-secondary-500',
  referral: 'bg-secondary-500',
  sitiowebpropio: 'bg-primary-500',
  sitioweb: 'bg-primary-500',
  webpropia: 'bg-primary-500',
  web: 'bg-primary-500',
  website: 'bg-primary-500',
  llamada: 'bg-call-500',
  llamadas: 'bg-call-500',
  llamadatelefonica: 'bg-call-500',
  telefono: 'bg-call-500',
  phone: 'bg-call-500',
  call: 'bg-call-500',
  email: 'bg-email-500',
  correo: 'bg-email-500',
  correoelectronico: 'bg-email-500',
  mail: 'bg-email-500',
  '2clics': 'bg-2clics-500',
  twoclics: 'bg-2clics-500',
  dosclics: 'bg-2clics-500',
  wasi: 'bg-wasi-500',
  toppropiedades: 'bg-toppropiedades-500',
  kiteprop: 'bg-kiteprop-500',
  otro: 'bg-neutral-400',
  otros: 'bg-neutral-400',
  other: 'bg-neutral-400',
  others: 'bg-neutral-400',
  unknown: 'bg-neutral-400',
  empty: 'bg-neutral-400',
};

const FALLBACK_COLOR_CLASSES = [
  'bg-info-500',
  'bg-teal-500',
  'bg-warning-500',
  'bg-rose-500',
  'bg-secondary-500',
  'bg-primary-500',
];

const normalizeSource = (value: string): string =>
  value
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]/gu, '');

/**
 * Chooses a source's shared brand color or a stable color for a custom value.
 * Recognizes template identifiers and display labels without altering the data.
 * @param key - Stable stored breakdown value as returned in the response.
 * @param label - Optional tenant display label, used as a brand alias fallback.
 * @returns A complete Tailwind background class for both bar and legend.
 */
export const getReportBreakdownColorClass = (
  key: string,
  label: string = key
): string => {
  const normalized = normalizeSource(key);
  if (Object.prototype.hasOwnProperty.call(SOURCE_COLOR_CLASSES, normalized)) {
    return SOURCE_COLOR_CLASSES[normalized];
  }
  const normalizedLabel = normalizeSource(label);
  if (
    Object.prototype.hasOwnProperty.call(SOURCE_COLOR_CLASSES, normalizedLabel)
  ) {
    return SOURCE_COLOR_CLASSES[normalizedLabel];
  }

  let hash = 0;
  for (const character of normalized) {
    hash = (Math.imul(hash, 31) + character.charCodeAt(0)) >>> 0;
  }
  return FALLBACK_COLOR_CLASSES[hash % FALLBACK_COLOR_CLASSES.length];
};
